import { Component, OnInit } from '@angular/core';
import templateString from './timeSlots.component.html';
import { ToastrService } from 'ngx-toastr';
import { BsModalService } from 'ngx-bootstrap/modal';
import { HttpClient } from '@angular/common/http';
import { TimeSlotFormComponent } from '../timeSlotForm';
import { TimeSlotChangeOrderComponent } from '../timeSlotChangeOrder';
import * as moment from 'moment';

@Component({
  standalone: false,
  template: templateString
})
export class TimeSlotsComponent implements OnInit {
    public timeSlots: any;

    constructor(
        private http: HttpClient,
        private toastr: ToastrService,
        private bsModalService: BsModalService
    ) { }

    refresh() {
        this.http.get("time_slots").subscribe((timeSlots: any) => {
            this.timeSlots = timeSlots;
        });
    }

    formatTime(value) {
        if (!value) {
            return "";
        }

        var matches = value.toString().match(/(\d{2}):(\d{2})/);
        return matches && value.toString().indexOf("T") == -1 ? matches[1] + ":" + matches[2] : moment(value).format("HH:mm");
    }

    create() {
        var bsModalRef = this.bsModalService.show(TimeSlotFormComponent, {
            initialState: {
                timeSlotId: null
            },
            class: 'modal-lg'
        });

        bsModalRef.content.action.subscribe(() => {
            this.refresh();
        });
    }

    edit(timeSlotId) {
        var bsModalRef = this.bsModalService.show(TimeSlotFormComponent, {
            initialState: {
                timeSlotId: timeSlotId
            },
            class: 'modal-lg'
        });

        bsModalRef.content.action.subscribe(() => {
            this.refresh();
        });
    }

    delete(timeSlotId) {
        if (window.confirm('Weet je het zeker?')) {
            this.http.delete("time_slots/" + timeSlotId).subscribe(() => {
                this.refresh();
            }, (response) => {
                this.toastr.error(response.error.error);
            });
        }
    }

    changeOrder() {
        var bsModalRef = this.bsModalService.show(TimeSlotChangeOrderComponent, {
            initialState: {
                originalTimeSlots: this.timeSlots
            }
        });

        bsModalRef.content.action.subscribe(() => {
            this.refresh();
        });
    }

    ngOnInit() {
        this.refresh();
    }
}
